import { Injectable } from '@angular/core';
import { Member } from '../models/member.model';
import { Notification } from '../models/notification.model';
import { CommonService } from './common.service';
import { DbService } from './db.service';
import { AlertService } from './alert.service';
import { PushService } from '../models/push.service';

@Injectable({
  providedIn: 'root'
})
export class DataService {

  constructor(private commonService: CommonService, private pushService: PushService, private db: DbService, private alertService: AlertService) { }

  // 알림 업데이트
  async updateNotification(uuid: Member['uuid'], content: Notification['content'], url = '', title: Notification['title'] = '알라딘크린') {
    try {
      const updateInfo: Notification = {
        id: this.commonService.generateFilename(),
        uuid: uuid,
        dateCreated: new Date().toISOString(),
        readSwitch: false,
        title,
        content,
        url,
      };
      // 관리자에서 알림 보내는 경우
      if (title !== '알라딘크린') {
        updateInfo.url = `/notification-detail?id=${updateInfo.id}`
      }
      const user = await this.db.toDoc$(`members/${uuid}`)
      await this.db.updateAt(`notifications/${updateInfo.id}`, updateInfo);
      if (user.pushSwitch && user.pushId?.length > 0) {
        await this.pushService.sendPush(
          user.pushId,
          content,
          {
            url: '/notification',
          },
        );
      }
    } catch (e) {
      this.alertService.errormsg(`업데이트 중 오류 발생\n${e}`);
      console.log(e);
    }
  }
}
